import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--right",
  "use": "icon-chevron--right-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"icon-chevron--right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m1.307 13.88 6.448-6.3a.805.805 0 0 0 0-1.158L1.307.12a.426.426 0 0 0-.592 0L.123.698a.403.403 0 0 0 0 .579l5.56 5.434a.403.403 0 0 1 0 .578l-5.56 5.434a.403.403 0 0 0 0 .579l.592.578c.163.16.428.16.592 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol